// @ts-nocheck
import { Draggable } from 'react-beautiful-dnd';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';

const SelectionCount = styled.div`
  right: -8px;
  top: -8px;
  color: #ffffff;
  background: rgb(50, 102, 139);
  border-radius: 50%;
  height: 30px;
  width: 30px;
  line-height: 30px;
  position: absolute;
  text-align: center;
  font-size: 0.8rem;
`;

const getItemStyle = (isDragging, isSelected, draggableStyle) => ({
  userSelect: 'none',
  border: isDragging || isSelected ? '1.5px solid #98C6F6' : '1.5px solid #e3e3e3',
  borderRadius: '8px',
  margin: '8px',
  with: '100%',
  position: 'relative',
  background: isDragging || isSelected ? 'rgb(222 237 248)' : '#ffffff',
  ...draggableStyle
});

/**
 * Functional React component for rendering a custom draggable element.
 *
 * @namespace Components
 *
 * @param {Object} props - The properties of the component.
 * @param {Object} props.item - Data containing information for the element.
 * @param {string} props.id - The unique identifier for the component.
 *
 * @returns {JSX.Element} - The rendered draggable component.
 */

const DraggableElement = ({ item, index, ...props }) => {
  const { selectedElements } = props;
  const { isSelected } = item;

  return (
    <Draggable
      key={`${item.id}`}
      draggableId={`${item.id}`}
      index={index}
      style={{ width: '100%' }}
      isDragDisabled={!isSelected}
      {...props}
    >
      {(provided, snapshot) => {
        const shouldShowSelection = snapshot.isDragging && selectedElements?.length > 1;
        return (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={getItemStyle(snapshot.isDragging, isSelected, {
              ...provided.draggableProps.style,
              ...props.style
            })}
          >
            {item.content}
            {shouldShowSelection ? <SelectionCount>{selectedElements?.length}</SelectionCount> : null}
          </div>
        );
      }}
    </Draggable>
  );
};

/**
 * Prop type definitions for DraggableElement.
 */
DraggableElement.propTypes = {
  item: PropTypes.object,
  index: PropTypes.number
};

export default DraggableElement;
